import Header from "./Header";
import Footer from "./Footer";
import { HashLink } from "react-router-hash-link";
import ScrollToTopButton from "./ScrollToTopButton";

const PackageDetails = () => {
  return (
    <>
      <Header />

      <section className="page">
        {/* <!-- package Details 1 --> */}
        <div className="d-flex justify-content-center pt-5  text-center pt-3 ">
          <div
            id="basic-wellness"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">
              Basic wellness package Men & Women & (outrage/ corporate events)
            </h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This is a Basic package general chemistry and micronutrient
              values; you won’t find a more comprehensive test profile out
              there. The Men’s and Women’s Complete Wellness profile is ideal
              for those wanting to establish a true baseline of their overall
              health.
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">BMI</li>
              <li className="list-unstyled">Waist circumference</li>
              <li className="list-unstyled">Waist to hip ratio</li>
              <li className="list-unstyled">Blood pressure</li>

              <li>
                {" "}
                Diabetes test (Fasting Blood Glucose (FBS) & Non-Fasting Glucose
                (RBS))
              </li>
              <li>
                {" "}
                lipid profile (Total Cholesterol, HDL Cholesterol,
                Triglycerides, LDL Cholesterol, Total Cholesterol/HDL Ratio,
                Non-HDL Cholesterol)
              </li>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 2 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3 ">
          <div
            id="executive-men"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium"> Executive Package for Men’s Wellness</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This is a comprehensive package general chemistry and
              micronutrient values to advanced assays including hormone levels,
              thyroid function, and factors related to heart health, you won’t
              find a more comprehensive test profile out there. The Men’s
              Complete Wellness profile is ideal for those wanting to establish
              a true baseline of their overall health.
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">BMI</li>
              <li className="list-unstyled">Full blood count</li>

              <li className="list-unstyled">Lipid profile</li>
              <li className="list-unstyled">Liver function test</li>
              <li className="list-unstyled">
                Diabetes test (Fasting Blood Glucose (FBS) & Non-Fasting
                Glucose(RBS))
              </li>
              <li className="list-unstyled">Routine Stool Examination</li>
              <li className="list-unstyled">Routine Urine Analysis </li>
              <li className="list-unstyled">Chest X-Ray </li>
              <li className="list-unstyled">ECG</li>
              <li className="list-unstyled">Ultra-sound (mini pack)</li>
              <li className="list-unstyled">Human Papilloma Virus (HPV) </li>
              <li className="list-unstyled">HbA1c </li>
              <li className="list-unstyled">
                Three tests for rheumatism; RF,ASO,CRP (50/50)
              </li>
              <li className="list-unstyled">
                Immune function：IgG,IgM,IgA,C3,C4 (optional){" "}
              </li>
              <li className="list-unstyled">PSA Test </li>
              <li className="list-unstyled">
                Hep B, Hep C, VDRL, HIV, HB Electrophoresis{" "}
              </li>
              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 3 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="executive-women"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">
              Executive Package for Women’s complete Wellness
            </h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This is a comprehensive package general chemistry and
              micronutrient values to advanced assays including hormone levels,
              thyroid function, and factors related to heart health, you won’t
              find a more comprehensive test profile out there. The Woman’s
              Complete Wellness profile is ideal for those wanting to establish
              a true baseline of their overall health.
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">BMI</li>
              <li className="list-unstyled">Full blood count</li>
              <h4 className="pt-2">Benefits</h4>
              <li className="list-unstyled">Lipid profile</li>
              <li className="list-unstyled">Liver function test</li>
              <li className="list-unstyled">Kidney function test</li>
              <li className="list-unstyled">Diabetes test</li>
              <li className="list-unstyled">
                Stool complete analysis (Routine Stool Examination)
              </li>
              <li className="list-unstyled">
                Urine complete analysis (Routine Urine Analysis){" "}
              </li>
              <li className="list-unstyled">ECG</li>
              <li className="list-unstyled">Ultra-sound Mini</li>
              <li className="list-unstyled">
                Thyroid function tests：TSH,FT3,FT4,T3,T4
              </li>
              <li className="list-unstyled">Human Papilloma Virus (HPV) </li>
              <li className="list-unstyled">
                Vaginal Swab R/E(Microscopy)+Bacterial Vaginitis{" "}
              </li>
              <li className="list-unstyled">HbA1c </li>
              <li className="list-unstyled">
                Three tests for rheumatism; RF,ASO,CRP
              </li>
              <li className="list-unstyled">
                Immune function：IgG,IgM,IgA,C3,C4 (optional){" "}
              </li>
              <li className="list-unstyled">
                Hep B, Hep C, VDRL, HIV, HB Electrophoresis{" "}
              </li>
              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 4 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="paediatric"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">Paediatric Wellness</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              Rapid has your “little one’s” covered designed to assess your
              child’s general health status. This profile is ideal for those
              wanting to establish a true baseline of their overall health.
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">FBC with ESR </li>
              <li className="list-unstyled">Blood grouping and RH Typing</li>
              <li className="list-unstyled">Routine Stool Test</li>
              <h4 className="pt-2">Benefits</h4>
              <li className="list-unstyled">Routine Urine Test</li>
              <li className="list-unstyled">
                Vitamin D(D25-oh) do we the machine
              </li>
              <li className="list-unstyled">
                Diabetes test: Random Blood Glucose
              </li>
              <li className="list-unstyled">Chest X-Ray</li>
              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 5 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="women's-hormone"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">Women’s Hormone Health</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              The tests included in this profile provide an invaluable
              assessment of the hormones that play a key role in energy levels,
              libido, mood, and overall quality of life.
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">Cortisol</li>
              <li className="list-unstyled">FSH</li>
              <li className="list-unstyled">LH (Luteinizing Hormone)</li>
              <li className="list-unstyled">Progesterone</li>
              <li className="list-unstyled">Prolactin</li>
              <li className="list-unstyled">Estradiol</li>
              <li className="list-unstyled">Total Testosterone </li>
              <li className="list-unstyled">TSH </li>
              <li className="list-unstyled">T3 Uptake </li>
              <li className="list-unstyled">T3 Uptake </li>
              <li className="list-unstyled">Free T4</li>
              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 6 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="men's-hormone"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">Men’s Hormone Health</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This profile may help you understand why. The Men’s Hormone Health
              Profile was developed specifically for men who want a
              comprehensive examination of the hormones that play a key role in
              energy levels, sex drive, mood, and overall quality of life.
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">Cortisol</li>
              <li className="list-unstyled">Estradiol</li>
              <li className="list-unstyled">Total Testosterone</li>
              <li className="list-unstyled">Total PSA</li>
              <li className="list-unstyled">TSH</li>
              <li className="list-unstyled">T3 Uptake</li>
              <li className="list-unstyled">Free T3 </li>
              <li className="list-unstyled">Free T4 </li>
              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 7 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="testosterone"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">Testosterone Level</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              Testosterone is a hormone produced primarily by the testes in men
              and the ovaries in women. This test provides detail about your
              testosterone levels and how they may be impacting your sex drive,
              energy levels, mood, body weight, and much more.
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">Total Cholesterol</li>
              <li className="list-unstyled">FSH </li>

              <li className="list-unstyled">LH (Luteinizing Hormone)</li>
              <li className="list-unstyled">LDL</li>
              <li className="list-unstyled">Triglycerides</li>
              <li className="list-unstyled">VLDL-C</li>
              <li className="list-unstyled">CK</li>
              <li className="list-unstyled">CK-MB</li>
              <li className="list-unstyled">hs-CRP</li>

              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 8 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="heart-health"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">Heart Health</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              Our Heart Health Profile includes a range of tests for monitoring
              overall heart health and helps in identifying certain factors that
              may lead to heart disease. Best of all, we make getting tested
              easy, so no more excuses!
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">Total Cholesterol</li>
              <li className="list-unstyled">LDL </li>
              <li className="list-unstyled">HDL</li>
              <li className="list-unstyled">Triglycerides</li>
              <li className="list-unstyled">VLDL-C</li>
              <li className="list-unstyled">CK</li>
              <li className="list-unstyled">CK-MB</li>
              <li className="list-unstyled">hs-CRP</li>

              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 9 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="thyroid-health"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">Thyroid Health</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This test provides specific detail about your thyroid function and
              the hormones that it releases. Thyroid hormones impact energy
              levels, body weight, body temperature, cholesterol levels, and
              much more!
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">TSH</li>
              <li className="list-unstyled">T3 Uptake </li>
              <li className="list-unstyled">T3 Total</li>
              <li className="list-unstyled">Free T3</li>
              <li className="list-unstyled">T4 Total</li>
              <li className="list-unstyled">Free T4</li>

              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 10 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="immune-health"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">Immune Health</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This profile was designed to help you evaluate possible
              deficiencies in your blood that may make you more susceptible to
              getting sick or may be contributing to the reason you seem to get
              sick more often than other people.
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">CBC(FBC) with Differential</li>
              <li className="list-unstyled">Total Testosterone </li>
              <li className="list-unstyled">Calcium</li>
              <li className="list-unstyled">Chloride</li>
              <li className="list-unstyled">Carbon Dioxide</li>
              <li className="list-unstyled">Glucose</li>
              <li className="list-unstyled">Potassium</li>
              <li className="list-unstyled">Sodium</li>
              <li className="list-unstyled">BUN</li>
              <li className="list-unstyled">Creatinine</li>
              <li className="list-unstyled">ALL</li>
              <li className="list-unstyled">ALT</li>
              <li className="list-unstyled">Albumin</li>
              <li className="list-unstyled">TSH</li>
              <li className="list-unstyled">HbA1c</li>
              <li className="list-unstyled">Insulin</li>
              <li className="list-unstyled">Folate</li>
              <li className="list-unstyled">Vitamin B12</li>
              <li className="list-unstyled">Vitamin D</li>

              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 11 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="basic-nutrition"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">Basic Nutrition & Lifestyle Risk</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This profile was designed to help you evaluate possible
              deficiencies in your blood that may make you more susceptible to
              getting sick or may be contributing to the reason you seem to get
              sick more often than other people.
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">Cortisol</li>
              <li className="list-unstyled">FSH </li>
              <li className="list-unstyled">LH (Luteinizing Hormone)</li>
              <li className="list-unstyled">Total Testosterone</li>
              <li className="list-unstyled">Progesterone</li>
              <li className="list-unstyled">Prolactin</li>
              <li className="list-unstyled">Estradiol</li>
              <li className="list-unstyled">TIBC</li>
              <li className="list-unstyled">UIBC</li>
              <li className="list-unstyled">Ferritin</li>
              <li className="list-unstyled">Iron</li>
              <li className="list-unstyled">Calcium</li>
              <li className="list-unstyled">Chloride</li>
              <li className="list-unstyled">Carbon Dioxide</li>
              <li className="list-unstyled">Glucose</li>
              <li className="list-unstyled">Potassium</li>
              <li className="list-unstyled">Sodium</li>
              <li className="list-unstyled">BUN</li>
              <li className="list-unstyled">Creatinine</li>
              <li className="list-unstyled">ALKP</li>
              <li className="list-unstyled">ALT</li>
              <li className="list-unstyled">AST</li>
              <li className="list-unstyled">Albumin</li>
              <li className="list-unstyled">Total Protein</li>
              <li className="list-unstyled">Total Bilirubin</li>
              <li className="list-unstyled">FBC with Differential</li>
              <li className="list-unstyled">CK</li>
              <li className="list-unstyled">TSH</li>
              <li className="list-unstyled">Creatinine</li>
              <li className="list-unstyled">Vitamin D</li>

              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 12 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="pre-operative"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">PRE-OPERATIVE TESTING</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This test is based on doctor’s rec or marketing to docs and
              hospital
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>
              <br />

              <h4>What this test Measures</h4>
              <li className="list-unstyled">FBC </li>
              <li className="list-unstyled">Liver function test </li>
              <li className="list-unstyled">Kidney function test</li>
              <li className="list-unstyled">
                Electrolyte examination: K, NA, CL, Ca, Mg, P, CO2
              </li>
              <li className="list-unstyled">Clotting Profile</li>
              <p>
                <h3 className="fw-medium"> Wellness recommendations</h3>
                If you need to cancel or reschedule your appointment, please
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 13 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="marriage"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">MARRIAGE PACKAGE</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This test is based on doctor’s rec or marketing to docs and
              hospital
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>

              <h4 className="pt-2">What this test Measures</h4>
              <li className="list-unstyled">Blood Group </li>
              <li className="list-unstyled">Genotype </li>
              <li className="list-unstyled">Syphillis</li>
              <li className="list-unstyled">HEP B</li>
              <li className="list-unstyled">HIV</li>
              <li className="list-unstyled">Urine R/E</li>
              <li className="list-unstyled">Pregnancy Test (Women)</li>

              <p>
                <h3 className="fw-medium pt-2"> Wellness recommendations</h3>
                <p className="p-0 ">
                  If you need to cancel or reschedule your appointment, please
                </p>
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 14 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="sti-screening"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">STI SCREENING PACKAGE</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This test is based on doctor’s rec or marketing to docs and
              hospital
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>

              <h4 className="pt-2">What this test Measures</h4>
              <li className="list-unstyled">Gonorrhoea </li>
              <li className="list-unstyled">Chlamydia </li>
              <li className="list-unstyled">Syphillis</li>
              <li className="list-unstyled">HEP B</li>
              <li className="list-unstyled">HIV</li>
              <li className="list-unstyled">Urine R/E</li>

              <p>
                <h3 className="fw-medium pt-2"> Wellness recommendations</h3>
                <p className="p-0 ">
                  If you need to cancel or reschedule your appointment, please
                </p>
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>

        {/* <!-- package Details 15 --> */}
        <div className="d-flex justify-content-center  pt-5  text-center pt-3">
          <div
            id="employee-health"
            className="container bg-warning-subtle px-2 pt-2 text-primary-emphasis border border-3 rounded-5 my-shadow col-lg-8 col-sm-12"
          >
            <h2 className="fw-medium">EMPLOYEE HEALTH SCREENING PACKAGE</h2>
            <p className="fs-4 w-100 text-start ">
              {" "}
              This test is based on doctor’s rec or marketing to docs and
              hospital
            </p>

            <ul className="text-start fs-4">
              <h4 className="">Collection of sample method</h4>
              <li className=""> In-person blood draw.</li>
              <li>Mobile Concierge </li>

              <h4 className="pt-2">What this test Measures</h4>
              <li className="list-unstyled">Sickling </li>
              <li className="list-unstyled">Blood Group </li>
              <li className="list-unstyled">Syphillis</li>
              <li className="list-unstyled">HEP B</li>
              <li className="list-unstyled">HEP C</li>
              <li className="list-unstyled">HIV</li>
              <li className="list-unstyled">FBC</li>
              <li className="list-unstyled">Genotype</li>
              <li className="list-unstyled">Chest X-ray</li>

              <p>
                <h3 className="fw-medium pt-2"> Wellness recommendations</h3>
                <p className="p-0 ">
                  If you need to cancel or reschedule your appointment, please
                </p>
                contact our support.
                <li className="list-unstyled"> 1. Time Schedule</li>
                <li className="list-unstyled"> 2. Your information</li>
                <li className="list-unstyled"> 3. Confirmation</li>
              </p>

              <h5 className="text-danger pt-3">
                Please do not eat or drink 10 hours prior to testing.
              </h5>

              <HashLink
                to="/forms#appointment-form"
                className="btn btn-primary"
              >
                {" "}
                <h5 className="fw-semibold pt-1">Schedule And Buy</h5>
              </HashLink>
            </ul>
          </div>
        </div>
      </section>
      <ScrollToTopButton />
      <Footer />
    </>
  );
};
export default PackageDetails;
